import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';

import config from '../../../../config.js';

import { getLoggedUser } from '../../../User/UserActions.js';
import { getUserGroup } from '../../../User/UserGroupActions.js';

import SocialShare from '../../../../components/Social/SocialShare.js';
import Icon from '../../../../components/Content/Icon.js';

function OrderMultiorderShare({ intl, order, user, userGroup }) {
	const url = `${config.url}${intl.locale}/?join=${user._id}-${order._id}&utm_campaign=multiorder&utm_medium=invitation&utm_source=`;
	return (
		<Fragment>
			<FormattedMessage id="orderMultiorderShareText" defaultMessage="Invite your friends, colleagues or family to participate in your group order" />
			<SocialShare
				url={`${url}{network}`}
				title={intl.formatMessage({
					id: 'orderMultiorderInviteTitle',
					defaultMessage: 'Join the bulk order on {app}',
				}, { app: config.application.name })}
				text={
					userGroup.discount > 0
					? intl.formatMessage({
						id: 'orderMultiorderInviteWithDiscountText',
						defaultMessage: '{user} invites you to join their bulk order to enjoy a {discount}% discount on your order on {app}!',
					}, { app: config.application.name, user: user.company || `${user.firstName || ''} ${user.lastName || ''}`, discount: userGroup.discount })
					: intl.formatMessage({
						id: 'orderMultiorderInviteText',
						defaultMessage: '{user} invites you to join their bulk order on {app}.',
					}, { app: config.application.name, user: user.company || `${user.firstName || ''} ${user.lastName || ''}` })
				}
			/>
			<Button variant="link" as="a" href={`https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&data=${encodeURIComponent(url)}qrcode`} target="_blank" className="w-100"><Icon icon="qr" /> <FormattedMessage id="orderMultiorderQRCodeGenerate" defaultMessage="Generate a QR-Code to share" /></Button>
		</Fragment>
	);
}

function mapStateToProps(store, props) {
    return {
        user: props.user || getLoggedUser(store),
        userGroup: getUserGroup(store),
    };
}

OrderMultiorderShare.propTypes = {
    intl: PropTypes.object.isRequired,
    order: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    userGroup: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(injectIntl(OrderMultiorderShare));
